import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { constants } from '../../../shared/constants/constants';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { NameWithDigitsFormControl } from '../name-with-digits-form-control/name-with-digits-form-control';
import { CheckboxListFormControl } from './checkbox-list-form-control';
import { LabelsDataService } from '@services/labels-data.service';

@Component({
  standalone: false,
  selector: 'app-checkbox-list-form-control',
  templateUrl: './checkbox-list-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxListFormControlComponent),
      multi: true
    }
  ]
})
export class CheckboxListFormControlComponent
  extends AbstractFormControlComponent<CheckboxListFormControl>
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() otherAnswer?: string;
  @Input() otherUniqClass?: string;
  @Input() inline: boolean;
  @Input() compact: boolean;
  @Output() onChanged: EventEmitter<boolean> = new EventEmitter();
  @Output() onOtherChange: EventEmitter<any> = new EventEmitter();

  constructor(public labelsDataService: LabelsDataService) {
    super();
  }

  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  faCheck: any = faCheck;
  otherAswer = constants.otherAnswer;

  form = new FormGroup({
    other: new NameWithDigitsFormControl(false, false, { capitalizeAll: false })
  });
  requiredText: string = '';

  ngOnInit(): void {
    if (this.otherAnswer) {
      this.form.patchValue({ other: this.otherAnswer });
    }

    this.requiredText = this.labelsDataService.getData(
      'COMMON.PleaseFillInThisFieldText'
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.otherAnswer &&
      changes?.otherAnswer.currentValue !== undefined
    ) {
      this.form.patchValue({ other: this.otherAnswer });
    }
  }

  otherChange(event: any): void {
    this.onOtherChange.emit(event);
  }

  change(): void {
    this.onChanged.emit(this.control.value);
    const otherControl = this.form.get('other') as NameWithDigitsFormControl;

    setTimeout(() => {
      if (this.isOtherAnswer) {
        otherControl.markAsRequred();

        setTimeout(() => {
          if (this.otherUniqClass) {
            let otherInputs = document
              .getElementsByClassName(this.otherUniqClass)[0]
              .getElementsByClassName('mat-mdc-input-element');

            let el = otherInputs[0] as any;
            if (!!el.value) {
              return;
            }
            el.focus();
          }
        });
      } else {
        otherControl.markAsNotRequred();
      }
    });
  }

  get isOtherAnswer(): boolean {
    if (!this.control.value) {
      return false;
    }

    return this.control.value?.indexOf(constants.otherAnswer) !== -1;
  }

  public get isInline(): boolean {
    return this.inline || false;
  }

  public get isCompact(): boolean {
    return this.compact || false;
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }

  public get hideErrorMessages(): boolean {
    return this.control.hideErrorMessages || false;
  }

  get class(): string {
    if (this.otherUniqClass) {
      return `no-title ${this.otherUniqClass}`;
    }

    return 'no-title';
  }

  public get multiple(): string {
    return this.control.multiple ? 'true' : 'false';
  }

  public get addOther(): boolean {
    return this.control.addOther ?? false;
  }

  public get otherId(): number {
    return this.control.otherId;
  }

  public get collection(): any[] {
    return this.control.collection || [];
  }

  public get keyPropertyName(): string {
    return this.control.keyPropertyName || 'name';
  }

  public get valuePropertyName(): string {
    return this.control.valuePropertyName || 'name';
  }
}
